module.exports = __webpack_public_path__ + "static/media/46@2x.a0636035.png";